module.exports = __webpack_public_path__ + "img/FLORALES.c9e6005f.png";